// src/App.js
import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Sidebar from "./Sidebar";
import SidebarLayout from "./SidebarLayout";
import AdminDashboard from "./components/AdminDashboard";
import Dashboard from "./components/Dashboard";
import TestingProjectDetails from "./components/TestingProjectDetails";
import IssueProjectSelection from "./components/IssueProjectSelection";
import TestingProjectSelection from "./components/TestingProjectSelection";
import ReportProjectSelection from "./components/ReportProjectSelection";
import ProjectSelection from "./components/ProjectSelection";
import CreateProject from "./components/CreateProject";
import ProjectActivation from "./components/projectDetails/ProjectActivation";
import RepoActivation from "./components/projectDetails/RepoActivation";
import EditProject from "./components/EditProject";
import ProjectDetails from "./components/ProjectDetails";
import RunDetails from "./components/RunDetails";
import IssueSelection from "./components/IssueSelection";
import IssueDetails from "./components/IssueDetails";
import UTGen from "./components/UTGen";
import PullRequestReview from "./components/PullRequestReview";
import SocketTest from "./components/projectDetails/SocketTest";
import CoverageReport from "./components/CoverageReport";
import BuildDetails from "./components/BuildDetails";
import Pipeline from "./components/Pipeline";
import LoginPage from "./components/Login";
import SignUpPage from "./components/SignUp";
import ForgotPassword from "./components/ForgotPassword";
import ProtectedRoute from "./components/ProtectedRoute";
import TokenExpiryModal from "./components/auth/TokenExpiryModal";
import IssueProjectDetails from "./components/IssueProjectDetails";
import SearchIcon from "@mui/icons-material/Search";
import SettingsIcon from "@mui/icons-material/Settings";
import MenuIcon from "@mui/icons-material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Profile from "./components/Profile";
import MemoryLeakDetails from "./components/projectDetails/MemoryDetails";
import LocDetails from "./components/LocDetails";
import OfflineBar from "./components/utilities/OfflineBar";
import StatusBar from "./components/utilities/StatusBar";
import NotFound from "./components/NotFound";
import CodeDiffViewer from "./components/staticAnalysis/CodeDiffViewer";
// import PublicLayout from "./components/layouts/PublicLayout";
// import MainLayout from "./components/layouts/MainLayout";
import aws from "./img/Amazon-Web-Services-AWS-Logo.png";
import profile from "./img/profile-image.png";
import { AuthProvider, useAuth } from "./context/AuthProvider";
import { jwtDecode } from "jwt-decode";
import { ToastContainer } from 'react-toastify';
import {
  CssBaseline,
  Box,
  Button,
  Toolbar,
  AppBar,
  Typography,
  TextField,
  IconButton,
  Menu,
  MenuItem,
  Divider,
  Drawer,
  useTheme,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Link,
  createTheme,
  ThemeProvider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./styles/app.css";
import ReportingRunDetails from "./components/ReportingRunDetails";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import ProfileAvatar from "./components/ProfileAvtar";
import CheckoutPage from "./components/CheckOut";
import Popup from "./components/PopUp";
const getInitialMode = () => {
  const savedMode = localStorage.getItem("themeMode");
  return savedMode ? savedMode : "light";
};
// Global error dialog component that appears on any API fetch error
const GlobalErrorDialog = ({ errorMessage, clearError }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLoginAgain = () => {
    localStorage.removeItem("access_token");
    clearError();
    navigate("/login");
  };

  return (
    <Dialog open={Boolean(errorMessage)}>
      <DialogTitle>
        Error
        <IconButton
          aria-label="close"
          onClick={clearError}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            ":hover": {
              color: "white",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">{errorMessage}</Typography>
        <Typography variant="caption" display="block" sx={{ mt: 2 }}>
          Having Problems?{" "}
          <Link
            href="https://athrvcloud.com/contact/"
            target="_blank"
            rel="noopener"
          >
            Contact Us
          </Link>
        </Typography>
      </DialogContent>
      <DialogActions>
        {location.pathname !== "/login" && (
          <Button
            onClick={handleLoginAgain}
            variant="contained"
            className="athrv-dash-primary-button"
          >
            Login Again
          </Button>
        )}
        {/* <Button onClick={clearError} variant="outlined">
          Close
        </Button> */}
      </DialogActions>
    </Dialog>
  );
};

function AppContent({ }) {
  const { isAuthenticated, planId } = useAuth();
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);
  const [selectedMenuItem, setSelectedMenuItem] = useState("dashboard");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [isProfileLoaded, setIsProfileLoaded] = useState(false);
  const [settingsAnchorEl, setSettingsAnchorEl] = useState(null);
  const [userData, setUserData] = useState(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem("access_token");
  const userName = localStorage.getItem("fname") || "Guest";
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:768px)");
  const [showGrettingsAndSearch, setShowGrettingsAndSearch] = useState(false);
  const [mode, setMode] = useState(getInitialMode);

  useEffect(() => {
    localStorage.setItem("themeMode", mode);
  }, [mode]);
  const theme1 = useMemo(
    () =>
      createTheme({
        palette: {
          mode: mode,
        },
        components: {
          MuiButton: {
            styleOverrides: {
              root: {
                color: mode === "dark" ? "white" : undefined,
              },
            },
          },
        },
      }),
    [mode]
  );

  const toggleTheme = () => {
    setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
  };
  const isDarkMode = theme1.palette.mode === "dark";

  // useEffect(() => {
  //   console.log("Route changed to:", location.pathname);
  //   // Perform actions based on the new route
  // }, [location]);

  // const handleMenuItemClick = (menuItem) => {
  //   setSelectedMenuItem(menuItem);
  // };

  // const [selectedProject, setSelectedProject] = useState(null);
  // const handleProjectSelect = (project) => {
  //   setSelectedProject(project);
  // };

  const isAuthPage =
    location.pathname === "/login" ||
    location.pathname === "/signup" ||
    location.pathname === "/" ||
    // location.pathname === "/codediff" ||
    location.pathname.startsWith("/repo/activate");

  // Only show header/sidebar if the user is logged in and NOT on an auth page
  const showLayout = isAuthenticated && !isAuthPage;

  const handleLogout = async () => {
    const token = localStorage.getItem("access_token");
    if (token) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_NEW_HOST_URL}/athrv/api/v1/auth/logout`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (response.ok) {
          localStorage.removeItem("access_token");
          localStorage.removeItem("fname");
          window.location.href = "/login";
        } else {
          console.error("Logout failed:", response.statusText);
        }
      } catch (error) {
        // Catch network-related errors
        if (error.message === "Failed to fetch") {
          // Set your offline state so that the global OfflineBar appears
          //   props.setIsOffline(true);
          // } else {
          console.error("Logout error:", error);
        }
      }
    } else {
      console.warn("No token found, redirecting to login");
      window.location.href = "/login";
    }
  };

  const handleSettingsClick = (event) => {
    setSettingsAnchorEl(event.currentTarget);
  };

  const handleSettingsClose = () => {
    setSettingsAnchorEl(null);
  };

  const handleMenuClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const toggleMobileSidebar = () => {
    setMobileOpen((prev) => !prev);
  };

  const handleMenuToggle = () => {
    setShowGrettingsAndSearch((prev) => !prev);
  };

  const seeProfile = () => {
    navigate("/profile");
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      const sidebar = document.querySelector(".mobile-sidebar");
      const drawerIcon = document.querySelector(".drawer-icon");
      if (
        mobileOpen &&
        sidebar &&
        !sidebar.contains(event.target) &&
        !drawerIcon.contains(event.target)
      ) {
        setMobileOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [mobileOpen]);



  return (
    <ThemeProvider theme={theme1}>
      <Box sx={{ display: "flex", overflow: "visible" }}>
        <CssBaseline />
        {showLayout && (
          <>
            <AppBar
              position="fixed"
              sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                left: isMobile ? 0 : isSidebarExpanded ? "250px" : "80px",
                width: isMobile
                  ? "100%"
                  : `calc(100% - ${isSidebarExpanded ? "250px" : "80px"})`,
                transition: "left 0.3s, width 0.3s",
                // backgroundColor: theme.palette.mode === "dark" ? "#202020" : "rgb(12, 20, 50)",
              }}
            >
              <Toolbar
                // athrv-header
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  backgroundColor: isDarkMode ? "#202020" : "rgb(12, 20, 50)",
                  padding: isMobile ? "0 0 0 10px" : "0 5px 0 5px !important",
                  borderBottom: "1px solid rgba(255, 255, 255, 0.3)",
                }}
              >
                {/* Mobile View: Only Drawer Icon, Settings Icon, and Three-Dot Menu */}
                {isMobile ? (
                  <>
                    {/* Drawer Icon */}
                    <IconButton
                      color="inherit"
                      onClick={toggleMobileSidebar}
                      className="drawer-icon"
                    >
                      <MenuIcon />
                    </IconButton>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      {/* Settings Icon */}
                      {/* <IconButton
                      color="inherit"
                      aria-label="settings"
                      onClick={handleSettingsClick}
                    >
                      <SettingsIcon />
                    </IconButton> */}

                      {/* Greeting */}
                      <Typography
                        variant="body1"
                        sx={{ marginRight: "20px", color: "white" }}
                      >
                        Hi, {userName}
                      </Typography>

                      {/* Three-Dot Menu */}
                      <IconButton
                        color="inherit"
                        onClick={handleSettingsClick}
                        sx={{ marginRight: "5px" }}
                      >
                        <MoreVertIcon />
                      </IconButton>
                    </Box>
                  </>
                ) : (
                  <>
                    {/* Desktop View: Sidebar Toggle, Search Bar, Greeting, and Settings */}
                    <SidebarLayout
                      isSidebarExpanded={isSidebarExpanded}
                      toggleSidebar={() =>
                        setIsSidebarExpanded(!isSidebarExpanded)
                      }
                    />
                    {/* User Greeting and Settings */}
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      {/* Server Details */}
                      <Box
                        sx={{
                          display: planId != "invalid" || planId == null ? "flex" : "none",
                          alignItems: "center",
                          padding: "8px 16px",
                          borderRadius: "8px",
                          transition: "border 0.3s ease",
                          mr: 1,
                          "&:hover": {
                            border: "transparent",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            width: 14,
                            height: 14,
                            bgcolor: "#5ced73",
                            borderRadius: "50%",
                            mr: 1.5,
                          }}
                        />
                        <Box
                          component="img"
                          src={aws}
                          alt="AWS"
                          sx={{ height: 36, mr: 1.5 }}
                        />
                        <Typography
                          variant="body1"
                          sx={{ color: "white", mr: 1.5 }}
                        >
                          Mumbai Server
                        </Typography>
                        <Typography variant="body1" sx={{ color: "#BBBCB6" }}>
                          (ap-south-1)
                        </Typography>
                      </Box>

                      <Box sx={{ mr: 2 }}>
                        <ProfileAvatar />
                      </Box>

                      {/* Greeting */}
                      <Typography
                        variant="body1"
                        sx={{ marginRight: "20px", color: "white" }}
                      >
                        Hi, {userName}
                      </Typography>

                      {/* Theme Toggle Icon */}
                      <IconButton color="inherit" onClick={toggleTheme}>
                        {mode === "light" ? (
                          <LightModeIcon />
                        ) : (
                          <DarkModeIcon />
                        )}
                      </IconButton>

                      {/* Settings Icon */}
                      <IconButton
                        color="inherit"
                        aria-label="settings"
                        onClick={handleSettingsClick}
                      >
                        <MoreVertIcon />
                      </IconButton>
                    </Box>
                  </>
                )}

                {/* Settings Menu (Displays Profile & Logout options) */}
                <Menu
                  anchorEl={settingsAnchorEl}
                  open={Boolean(settingsAnchorEl)}
                  onClose={handleSettingsClose}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  <MenuItem onClick={seeProfile}>Profile</MenuItem>
                  <MenuItem onClick={handleLogout}>Logout</MenuItem>
                </Menu>

                {/* Show Greeting & Search Bar when Three-Dot Menu is Clicked */}
                {isMobile && showGrettingsAndSearch && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: "56px",
                      left: "0",
                      width: "100%",
                      bgcolor: "#0C1A32",
                      padding: "10px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    {/* Search Bar */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        bgcolor: "white",
                        borderRadius: "4px",
                        padding: "0 10px",
                        width: "100%",
                      }}
                    >
                      <SearchIcon sx={{ color: "gray" }} />
                      <TextField
                        variant="standard"
                        placeholder="Search..."
                        InputProps={{
                          disableUnderline: true,
                          style: { fontSize: "14px", marginLeft: "10px" },
                        }}
                        sx={{ width: "100%" }}
                      />
                    </Box>

                    {/* Greeting */}
                    <Typography
                      variant="body1"
                      sx={{ color: "white", textAlign: "center" }}
                    >
                      Hi, {userName}
                    </Typography>
                  </Box>
                )}
              </Toolbar>
            </AppBar>

            {/* Sidebar: Hide when screen < 768px */}
            {!isMobile && (
              <Box
                component="nav"
                sx={{
                  width: isSidebarExpanded ? 250 : 80,
                  flexShrink: { sm: 0 },
                  background: "#0C1A32",
                  transition: "width 0.3s",
                }}
              >
                <Sidebar isSidebarExpanded={isSidebarExpanded} />
              </Box>
            )}
            {isMobile && mobileOpen && (
              <Box
                component="nav"
                className="mobile-sidebar"
                sx={{
                  width: 250,
                  flexShrink: { sm: 0 },
                  background: "#0C1A32",
                }}
              >
                <Sidebar isSidebarExpanded={true} />
              </Box>
            )}
          </>
        )}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: isAuthPage ? 0 : 3,
            width: isMobile
              ? "100%"
              : `calc(100% - ${isAuthPage ? 0 : isSidebarExpanded ? 250 : 80
              }px)`,
            marginTop: !showLayout ? 0 : "64px",
            height: "auto",
            overflowY: isMobile ? "auto" : "visible",
            padding: 0,
          }}
        >
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<LoginPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/codediff" element={<CodeDiffViewer />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admindashboard"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/projects/:projectId/issues/:issueKey/pr-review" 
              element={<PullRequestReview />} 
            />
            <Route
              path="/projects"
              element={
                <ProtectedRoute>
                  <ProjectSelection />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/create"
              element={
                <ProtectedRoute>
                  <CreateProject />
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/activation/"
              element={
                <ProtectedRoute>
                  <ProjectActivation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/:projectId/edit"
              element={
                <ProtectedRoute>
                  <EditProject />
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/:projectId"
              element={
                <ProtectedRoute>
                  <ProjectDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/issues/:projectId"
              element={
                <ProtectedRoute>
                  <IssueProjectDetails />
                </ProtectedRoute>
              }
            />
            <Route
            path="/projects/:projectId/loc-details"
            element={
              <ProtectedRoute>
                <LocDetails />
              </ProtectedRoute>
            }
          />
            <Route
              path="/projects/testing/:projectId"
              element={
                <ProtectedRoute>
                  <TestingProjectDetails />
                </ProtectedRoute>
              }
            />

            <Route
              path="/checkout/:planId"
              element={
                <ProtectedRoute>
                  <CheckoutPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/:projectId/build"
              element={
                <ProtectedRoute>
                  <BuildDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rundetails/:runId"
              element={
                <ProtectedRoute>
                  <RunDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rundetails/reporting/:runId"
              element={
                <ProtectedRoute>
                  <ReportingRunDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pipeline/:runId"
              element={
                <ProtectedRoute>
                  <Pipeline />
                </ProtectedRoute>
              }
            />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="/choose-plan" element={<ProtectedRoute><Popup /></ProtectedRoute>} />

            {/* <Route path="/pipeline/:runId" element={<ProtectedRoute element={Pipeline} />} /> */}

            <Route
              path="/issues/:projectId"
              element={
                <ProtectedRoute>
                  <IssueSelection />
                </ProtectedRoute>
              }
            />
            <Route
              path="/issues/:projectId/:issueKey"
              element={
                <ProtectedRoute>
                  <IssueDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports/cpputest/:projectId/:toolId"
              element={
                <ProtectedRoute>
                  <CoverageReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/repo/activate"
              element={
                <ProtectedRoute>
                  <RepoActivation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/issues"
              element={
                <ProtectedRoute>
                  <IssueProjectSelection />
                </ProtectedRoute>
              }
            />
            <Route
              path="/testing"
              element={
                <ProtectedRoute>
                  <TestingProjectSelection />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ai/testing"
              element={
                <ProtectedRoute>
                  <UTGen />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ai/test"
              element={
                <ProtectedRoute>
                  <SocketTest />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reporting"
              element={
                <ProtectedRoute>
                  <ReportProjectSelection />
                </ProtectedRoute>
              }
            />
            {/* Add additional protected/public routes as needed */}
            {/* Catch-all route for undefined paths */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

function App() {
  const [status, setStatus] = useState(null);
  const [showBackOnlineBar, setShowBackOnlineBar] = useState(false);
  const [globalApiError, setGlobalApiError] = useState(null);

  const delay = (ms) => new Promise((res) => setTimeout(res, ms));

  // Function to check connectivity (used for periodic re-checks)
  const checkConnectivity = useCallback(async () => {
    try {
      // Option 1: Use navigator.onLine (quick but may not catch all issues)
      // console.log("nav not online")
      if (navigator.onLine) {
        // Option 2: Optionally ping a lightweight resource for a more reliable check
        await fetch("https://www.google.com", { mode: "no-cors" });
        // Connectivity is fine: clear any error status and show back online message
        setStatus(null);
        setShowBackOnlineBar(true);
        setTimeout(() => setShowBackOnlineBar(false), 3000);
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  }, []);

  // Override global fetch to catch connectivity issues or API errors
  useEffect(() => {
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      try {
        const response = await originalFetch(...args);

        // console.log("response =", response);

        // Clone the response so that we can log the body without consuming the original stream.
        // const responseClone = response.clone();
        // const contentType = response.headers.get("content-type");

        // if (contentType && contentType.includes("application/json")) {
        //   responseClone
        //     .json()
        //     .then((data) => console.log("API response JSON:", data))
        //     .catch((err) => console.log("Error parsing JSON:", err));
        // } else {
        //   responseClone
        //     .text()
        //     .then((text) => console.log("API response text:", text))
        //     .catch((err) => console.log("Error reading text:", err));
        // }

        // Check for 401 Unauthorized
        if (response.status === 401) {
          // Instead of checking the response body, check if the token is expired.
          const jwtToken = localStorage.getItem("access_token");
          let tokenExpired = true;
          try {
            const { exp } = jwtDecode(jwtToken);
            tokenExpired = Date.now() >= exp * 1000;
          } catch (error) {
            console.error("Invalid token format", error);
            tokenExpired = true;
          }

          if (tokenExpired && localStorage.getItem("remember_me") === "true") {
            // Attempt to refresh the token.
            const refreshResponse = await originalFetch(
              `${process.env.REACT_APP_API_NEW_HOST_URL}/athrv/api/v1/auth/refresh`,
              {
                method: "POST",
                headers: {
                  Authorization: `Bearer ${localStorage.getItem(
                    "refresh_token"
                  )}`,
                  "Content-Type": "application/json",
                },
              }
            );
            if (refreshResponse.ok) {
              const refreshData = await refreshResponse.json();
              const newToken = refreshData.access_token;
              localStorage.setItem("access_token", newToken);

              // Clone the original request and update its Authorization header.
              const newArgs = [...args];
              if (newArgs[1] && newArgs[1].headers) {
                newArgs[1].headers["Authorization"] = `Bearer ${newToken}`;
              } else {
                newArgs[1] = {
                  ...newArgs[1],
                  headers: {
                    Authorization: `Bearer ${newToken}`,
                  },
                };
              }
              // Retry the original request with the updated token.
              response = await originalFetch(...newArgs);
              return response;
            } else {
              throw new Error("Unable to refresh token");
            }
          }
        }

        if (!response.ok) {
          const url = args[0];
          const isAuthEndpoint = url.includes('/auth/register') || url.includes('/auth/login') || url.includes('/auth/verify-otp');
  
  // Only show maintenance status for server errors (5xx) on non-auth endpoints
        if (!isAuthEndpoint && response.status >= 500) {
          setStatus({ message: response.statusText, type: "maintenance" });
        }
  
  // Don't throw error - let components handle their own error responses
        }
        return response;
      } catch (error) {
        if (error.message === "Failed to fetch") {
          try {
            // console.log("error =", error);
            // console.error("Full error details:", {
            //   message: error.message,
            //   name: error.name,
            //   stack: error.stack,
            //   ...error,
            // });
            // Try to ping a lightweight resource using the original fetch.
            await originalFetch("https://www.google.com", { mode: "no-cors" });
            // If connectivity check passes, assume server maintenance
            // setGlobalApiError("Maintenance Mode :  The server might be under maintenance.");
            setStatus({ message: error.message, type: "maintenance" });

            // setGlobalApiError("Maintenance Mode :");
            // throw new Error("Server under maintenance");
          } catch (connectivityError) {
            // If connectivity check fails, mark as offline
            if (!navigator.onLine) {
              setStatus({ message: "No Internet Connection", type: "offline" });
            }
          }
        }
        throw error;
      }
    };
  }, []);

  // Re-check connectivity every 5 seconds when offline
  useEffect(() => {
    let interval;
    if (status && status.type === "offline") {
      setGlobalApiError(null);
      interval = setInterval(checkConnectivity, 5000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [status, checkConnectivity]);

  return (
    <AuthProvider>
      <ToastContainer />
      <Router>
        <StatusBar
          status={status}
          showBackOnline={showBackOnlineBar}
          onRetry={checkConnectivity}
          onClose={() => setStatus(null)}
        />
        <TokenExpiryModal />
        {/* Global Error Dialog */}
        <GlobalErrorDialog
          errorMessage={globalApiError}
          clearError={() => setGlobalApiError(null)}
        />
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
